<template>
  <div id="app">
    <div v-if="simpleLayout">
      <router-view/>
    </div>
    <div v-else>
      <dashboard>
        <router-view/>
      </dashboard>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Dashboard from '@/components/Dashboard'

export default {
  name: 'App',
  components: {
    Dashboard
  },
  data() {
    return {};
  },
  created() {
    if (this.isAdPixelPro) {
      document.title = 'App - AD PIXEL PRO'
    } else {
      document.title = 'App - Único Tracker'
    }
  },
  mounted() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://kit.fontawesome.com/a099bc517f.js')
      document.head.appendChild(recaptchaScript)
  },
  computed: {
      ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isAdPixelPro() {
      const currentDomain = window.location.hostname;
      if (currentDomain.includes("adpixel.pro")) {
        return true
      }

      return false
    },
    simpleLayout() {
      return (
        !this.user ||
        !this.user.token ||
        [
          "Account",
          "Onboarding",
          "SelectPlan",
          "CanceledAccount",
          "GoogleAdsSelectAccounts",
          "FacebookAdsSelectAccounts",
          "AcceptInvite",
          "LoginOauthG",
          "LoginOauthFB",
          "NuvemShop",
          "Yampi",
          "LoginOauthNS",
          "VerifiedTag",
        ].includes(this.$route.name)
      );
    },
  },
  methods: {
  },


}
</script>
